// AGC: GPS utility functions — open coordinates in Google Maps, format coordinates

import { Capacitor } from '@capacitor/core'

/**
 * AGC: Open GPS coordinates in Google Maps (native browser or in-app)
 */
export const openInGoogleMaps = (lat: number, lng: number): void => {
  const url = `https://www.google.com/maps?q=${lat},${lng}`
  if (Capacitor.isNativePlatform()) {
    // AGC: On native, window.open opens the system browser / Maps app
    window.open(url, '_system')
  } else {
    window.open(url, '_blank')
  }
}

/**
 * AGC: Format coordinates for display (6 decimal places)
 */
export const formatCoordinates = (lat: number, lng: number): string => {
  return `${lat.toFixed(6)}, ${lng.toFixed(6)}`
}
